import { render, staticRenderFns } from "./QuestionInputRankOrder.vue?vue&type=template&id=a89b0492&scoped=true&"
import script from "./QuestionInputRankOrder.vue?vue&type=script&lang=js&"
export * from "./QuestionInputRankOrder.vue?vue&type=script&lang=js&"
import style0 from "./QuestionInputRankOrder.vue?vue&type=style&index=0&id=a89b0492&prod&scoped=true&lang=css&"
import style1 from "./QuestionInputRankOrder.vue?vue&type=style&index=1&id=a89b0492&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b0492",
  null
  
)

export default component.exports